import { SettingsSection } from '@/modules/external/components/customer/settings/settings-section.component';
import { useTranslation } from 'react-i18next';
import MyAddressesComponent from '../../components/customer/account/my-addresses.component';

export function SettingsAddressesPage() {
  const { t } = useTranslation('customer');

  return (
    <SettingsSection
      title={t('settings.addresses.title')}
      description={t('settings.addresses.description')}
    >
      <MyAddressesComponent />
    </SettingsSection>
  );
}
